import React from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../styles/theme';
import Button from './ui/Button';
import { FaTimesCircle } from 'react-icons/fa';

const SubscriptionCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '80vh',
      padding: '24px'
    }}>
      <div style={{
        maxWidth: '600px',
        textAlign: 'center',
        backgroundColor: theme.colors.surface,
        padding: '48px',
        borderRadius: '12px',
        border: `1px solid ${theme.colors.border}`
      }}>
        {/* Cancel Icon */}
        <div style={{
          display: 'inline-flex',
          padding: '24px',
          backgroundColor: '#FEE2E2',
          borderRadius: '50%',
          marginBottom: '24px'
        }}>
          <div style={{ color: '#DC2626' }}>
            {FaTimesCircle({ size: 64 })}
          </div>
        </div>

        {/* Title */}
        <h1 style={{
          fontSize: theme.typography.sizes['3xl'],
          fontWeight: theme.typography.weights.bold,
          color: theme.colors.text.primary,
          marginBottom: '16px'
        }}>
          Subscription Cancelled
        </h1>

        {/* Message */}
        <p style={{
          fontSize: theme.typography.sizes.lg,
          color: theme.colors.text.secondary,
          marginBottom: '32px',
          lineHeight: 1.6
        }}>
          Your subscription upgrade was cancelled. You can still upgrade anytime from the pricing page or your dashboard.
        </p>

        {/* CTA Buttons */}
        <div style={{
          display: 'flex',
          gap: '16px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <Button
            variant="primary"
            size="lg"
            onClick={() => navigate('/dashboard')}
          >
            Go to Dashboard
          </Button>
          <Button
            variant="secondary"
            size="lg"
            onClick={() => navigate('/pricing')}
          >
            View Pricing
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
